/* ============================================================
   NB · Animation System · Behaviors
   ------------------------------------------------------------
   - IntersectionObserver-based scroll reveals (.nb-reveal,
     .nb-reveal-stagger). Triggers once at 20% visibility.
   - Add-To-Cart button "✓ Added" success state. Augments — does
     not hijack — the existing product-form flow. Listens to
     cartUpdate, finds the source button, animates 2s.
   - Cart badge pulse helper exposed for other scripts to call.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- 1. Scroll-In Reveals ---------- */
  function initReveals() {
    var nodes = document.querySelectorAll(".nb-reveal, .nb-reveal-stagger");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      /* Fallback: show everything immediately */
      nodes.forEach(function (n) { n.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    nodes.forEach(function (n) { observer.observe(n); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveals);
  } else {
    initReveals();
  }

  /* ---------- 2. ATC Button · Success State ---------- */
  /* Track the form most recently submitted to /cart/add so we
     can animate its button when cartUpdate fires. */
  var lastSubmittedForm = null;
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target && e.target.closest
        ? e.target.closest('form[action*="/cart/add"]')
        : null;
      if (form) lastSubmittedForm = form;
    },
    true /* capture phase — runs before product-form's listener */
  );

  function animateAtcSuccess(btn) {
    if (!btn) return;
    if (btn.dataset.nbAtcAnimating === "1") return;
    btn.dataset.nbAtcAnimating = "1";

    /* Snapshot original content + styles, then morph */
    var originalHTML = btn.innerHTML;
    btn.dataset.nbAtcOriginalHtml = originalHTML;

    btn.classList.add("nb-atc-success");
    btn.innerHTML = "<span>✓ Added</span>";

    setTimeout(function () {
      btn.classList.remove("nb-atc-success");
      btn.innerHTML = btn.dataset.nbAtcOriginalHtml || originalHTML;
      delete btn.dataset.nbAtcAnimating;
      delete btn.dataset.nbAtcOriginalHtml;
    }, 2000);
  }

  function bindAtcSuccess() {
    if (
      !window.MinimogEvents ||
      !window.MinimogTheme ||
      !window.MinimogTheme.pubSubEvents ||
      !window.MinimogTheme.pubSubEvents.cartUpdate
    ) {
      return setTimeout(bindAtcSuccess, 50);
    }

    window.MinimogEvents.subscribe(
      window.MinimogTheme.pubSubEvents.cartUpdate,
      function (response) {
        if (!lastSubmittedForm) return;
        /* Skip on errors — server-side error response carries `status` */
        if (response && response.status) {
          lastSubmittedForm = null;
          return;
        }
        var btn = lastSubmittedForm.querySelector(
          'button[type="submit"], button[name="add"], [name="add"]'
        );
        if (btn) animateAtcSuccess(btn);
        lastSubmittedForm = null;
      }
    );
  }
  bindAtcSuccess();

  /* ---------- 3. Cart Badge Pulse helper ---------- */
  /* Public hook so other modules (or the cart drawer JS) can
     trigger a unified pulse via .is-pulsing without duplicating
     the keyframes. */
  window.NB = window.NB || {};
  window.NB.pulseCartBadge = function pulseCartBadge() {
    var badges = document.querySelectorAll(
      ".nb-cart-badge, .m-cart-count-bubble, [data-cart-count]"
    );
    badges.forEach(function (b) {
      b.classList.remove("is-pulsing");
      // eslint-disable-next-line no-unused-expressions
      b.offsetWidth; /* force reflow so animation restarts */
      b.classList.add("is-pulsing");
      setTimeout(function () {
        b.classList.remove("is-pulsing");
      }, 550);
    });
  };

  /* Wire pulse to cartUpdate too (covers cart-icon badge in
     header even when the drawer is not the trigger). */
  function bindBadgePulse() {
    if (
      !window.MinimogEvents ||
      !window.MinimogTheme ||
      !window.MinimogTheme.pubSubEvents ||
      !window.MinimogTheme.pubSubEvents.cartUpdate
    ) {
      return setTimeout(bindBadgePulse, 50);
    }
    window.MinimogEvents.subscribe(
      window.MinimogTheme.pubSubEvents.cartUpdate,
      function () {
        window.NB.pulseCartBadge();
      }
    );
  }
  bindBadgePulse();
})();
